import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
	body {
		font-family: 'Roboto';
		padding: 20px 40px;

		@media screen and (max-width: 800px) {
			padding: 10px 5px
		}
	}

	a {
		text-decoration: none;
		color: black;
	}

	h1 {
		color: #337ab7;
		font-family: 'Montserrat';
	}

	* {
		box-sizing: border-box;
	}
`;
